import { render, staticRenderFns } from "./LeftTab.vue?vue&type=template&id=0cd82e86&scoped=true&"
import script from "./LeftTab.vue?vue&type=script&lang=js&"
export * from "./LeftTab.vue?vue&type=script&lang=js&"
import style0 from "./LeftTab.vue?vue&type=style&index=0&id=0cd82e86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd82e86",
  null
  
)

export default component.exports